'use strict';

angular
  .module('webAgro1App')
  // eslint-disable-next-line max-params, max-lines-per-function
  .controller('ResumoStandCtrl', function($scope, $route, $rootScope, $templateCache, $timeout, $q,
    AtividadesService, OperacoesService, LoadingService, OperacoesDadosService, ChartsService, ContagensService,
    MessagesService, TarefaObjectService, InformacoesCultivaresService, $filter, $routeParams) {
    const getGroupMarkersCultivares = function(markers) {
      return markers.reduce(function(result, record) {
        if (!record.leafletMarker) {
          record = {
            leafletMarker: record,
            objeto: record.objeto
          };
        }
        result[record.objeto.cultivarForGroup.id] = result[record.objeto.cultivarForGroup.id] || [];
        result[record.objeto.cultivarForGroup.id].push(record);
        return result;
      }, {});
    };

    const getTipoTarefa = function() {
      return TarefaObjectService.getTarefaTipo('stand');
    };

    // eslint-disable-next-line max-lines-per-function
    $scope.getSummary = function(markers, event) {
      LoadingService.showLoading();

      if (event) {
        event.preventDefault();
      }

      if (($scope.details || []).leafletMarkers) {
        $scope.$emit('setMarkers', $scope.details.leafletMarkers);
      }

      $scope.details = null;
      const firstMarker = markers[0] || {};
      $scope.filters.gleba = $scope.activity.gleba;
      $scope.filters.cultivar = {
        id: firstMarker.objeto.cultivar_id || firstMarker.objeto.params.cd_insumo
      };
      $scope.filters.safra = firstMarker.objeto.params.safra_id;
      OperacoesService.getOperationSummary($scope.filters).then(function(result) {
        result = result[0] || {};
        result.gleba = $scope.activity.gleba;
        result.markers = markers;
        if (result.atividade) {
          result.atividade.isCorn = AtividadesService.isCorn(result.atividade.descricao);
          result.atividade.isCana = AtividadesService.isCana(result.atividade.descricao);
        }

        $scope.$emit('setMarkers', markers);

        if (result.quantidade) {
          ChartsService.loaderStandProductivity(result.markers, '#chartStand', '#containerChartStand');
        }

        $scope.details = result;
        if (!$scope.details.gleba) {
          $scope.details.gleba = _.find($scope.$root.currentPropriedade.glebas, {
            id: $scope.activity.id || (+$routeParams.activeGleba)
          });
        }

        if (hasInformedDistance(result.markers)) {
          ChartsService.loaderStandDistribution(activeMarkers(), '#chartDistribution', '#containerChartDistribution');
        }

        $rootScope.standMarkers = $scope.details.markers;
      })
        .finally(LoadingService.hideLoading);
    };


    $scope.setAnimationMarker = function(marker) {
      $scope.indexMarker = marker.id;
      $scope.$emit('startAnimatingMarker', marker);
    };

    $scope.resetAnimationMarker = function(marker) {
      $scope.$emit('stopAnimatingMarker', marker);
      $scope.indexMarker = null;
    };

    $scope.openMarkerInfoWindow = function(marker) {
      $scope.$emit('openMarkerPopup', marker);
    };

    function setCultivaresMarkerTooltip() {
      const markers = $scope.cultivaresMarker[_.keys($scope.cultivaresMarker)[0]];

      markers.forEach(({ leafletMarker, objeto }) => {
        let markerText = `Plantas/ha: ${formatNumber(objeto.realized)}`;
        if (objeto.isCana) {
          markerText = `Área Cana média por ha: ${formatNumber(objeto.avg_area)}`;
        }
        leafletMarker.bindTooltip(markerText);
      });
    }

    function InitializeStand(activity, markers) {
      LoadingService.showLoading();
      $rootScope.initialize.then(function() {
        markers = markers.filter((marker) => marker.objeto.stand);
        $scope.details = null;
        $scope.activity = activity;
        $rootScope.tipoTarefa = getTipoTarefa();
        $scope.tipo = 'stand';
        $scope.filters = {
          dia: $scope.activity.data,
          operacao: {
            tipo: $scope.tipo
          }
        };

        /* Reseta os markers */
        $scope.$emit('setMarkers', $scope.data.data.stand[0].objeto.allLeafletMarkers);

        $scope.cultivaresMarker = getGroupMarkersCultivares(markers);
        setCultivaresMarkerTooltip();
        const cultivar = ($scope.filters.cultivar || {}).id;
        if (!$scope.cultivaresMarker[cultivar]) {
          $scope.filters.cultivar = null;
        }

        $scope.getSummary($scope.cultivaresMarker[cultivar || Object.keys($scope.cultivaresMarker)[0]]);
      }, $rootScope.errorRootInitialize);
    }

    function formatNumber(number) {
      return Intl.NumberFormat(
        'pt-BR',
        {
          maximumFractionDigits: 2
        }
      ).format(number);
    }

    // eslint-disable-next-line max-lines-per-function, complexity
    function InitializeSummary() {
      const activity = $scope.data.activity || $scope.data.summary;
      const hasStandActive = activity.gerais.stand.some((stand) => stand.active);
      if (hasStandActive) {
        LoadingService.showLoading();
        $scope.details = null;
        $scope.activity = activity && (activity.history || activity);
        $rootScope.tipoTarefa = getTipoTarefa();
        $scope.tipo = 'standSummary';
        $scope.filters = {
          dataFinal: $scope.activity.data || null,
          operacao: { tipo: 'stand' },
          gleba: $scope.activity.gleba || {
            id: ($scope.activity.stand && $scope.activity.stand.gleba_id) || $scope.activity.id
          },
          cultivar: { id: (activity.stand || $scope.data.stand || {}).cultivar_id }
        };

        OperacoesService.getOperationSummary($scope.filters).then(function(result) {
          result = result[0] || {};
          const template = $templateCache.get('views/infowindow_templates/infowindowoperations.tpl.html');

          const markers = OperacoesDadosService.newGetMarkersOperationsDayGleba(result.pontos, null, template);
          $scope.cultivaresMarker = getGroupMarkersCultivares(markers);
          result.gleba = $scope.activity.gleba;
          result.markers = $scope.cultivaresMarker[Object.keys($scope.cultivaresMarker)[0]];
          result.markers = _.orderBy(result.markers, 'objeto.created_at');
          result.atividade.isCorn = AtividadesService.isCorn(result.atividade.descricao);
          result.atividade.isCana = AtividadesService.isCana(result.atividade.descricao);

          setCultivaresMarkerTooltip();

          $scope.$emit('setMarkers', result.markers);
          ChartsService.loaderStandProductivity(result.markers, '#chartStand', '#containerChartStand');

          $scope.details = result;
          if (!$scope.details.gleba) {
            $scope.details.gleba = _.find($scope.$root.currentPropriedade.glebas, {
              id: $scope.activity.id || (+$routeParams.activeGleba)
            });
          }

          if (hasInformedDistance(result.markers)) {
            ChartsService.loaderStandDistribution(activeMarkers(), '#chartDistribution', '#containerChartDistribution');
          }
          $rootScope.standMarkers = result.markers;
        })
          .finally(LoadingService.hideLoading);
      }
    }

    $scope.$watch('data', function() {
      if ($scope.data) {
        if ($scope.data.notification && $scope.data.data) {
          return InitializeStand($scope.data.activity, $scope.data.data.stand[0].objeto.allLeafletMarkers);
        }
        InitializeSummary();
      }
    });

    $scope.changeIdealDensity = function() {
      ContagensService.changeIdealDensity($scope.details).then(function() {
        reload();
      }, function(erroForUser) {
        if (erroForUser) {
          MessagesService.alert(erroForUser);
        }
      });
    };

    function reload(marker) {
      if (marker) {
        $rootScope.filtersPropriedade = {
          dataInicial: marker.created_at,
          gleba: {
            id: marker.params.gleba_id,
            descricao: marker.gleba
          },
          operacao: {
            id: $scope.tipo
          },
          cultivar: marker.params.cd_insumo,
          isStandSummary: marker.tipo === 'standSummary',
          clickNotificacao: $scope.tipo
        };
      } else if ($scope.history) {
        $rootScope.filtersPropriedade = {
          dataInicial: $scope.history.data,
          gleba: $scope.history.gleba,
          operacao: {
            id: $scope.tipo
          },
          cultivar: $scope.filters.cultivar,
          isStandSummary: $scope.tipo === 'standSummary',
          clickNotificacao: $scope.tipo
        };
      }

      $route.reload();
    }

    $scope.getPeriodo = function(details) {
      if (!details) {
        return;
      }
      const datas = details.pontos.map(function(ponto) {
        return new Date(ponto.created_at);
      });

      return {
        inicio: _.min(datas),
        fim: _.max(datas)
      };
    };

    // eslint-disable-next-line max-lines-per-function
    $scope.print = function() {
      $scope.report = {
        date: new Date()
      };
      const params = {
        tp_insumo: 1,
        tipo: 1,
        safra: $scope.details.markers[0].objeto.params.safra_id,
        gleba: $scope.details.markers[0].objeto.params.gleba_id,
        insumo: $scope.details.markers[0].objeto.params.cd_insumo,
        cd_insumo: $scope.details.markers[0].objeto.params.cd_insumo
      };

      LoadingService.showLoading();

      // Pontos
      $scope.report.pontos = $scope.details.markers.filter(function(marker) {
        return marker.objeto.registroAtivo;
      });

      // Número máximo de linhas
      $scope.report.maxLines = _.max($scope.report.pontos.map(function(marker) {
        return marker.objeto.lines.length;
      }));

      // Responsáveis
      $scope.report.responsaveis = _.uniq(_.map($scope.report.pontos, 'objeto.user.user_name')).join(',');

      const promises = [];

      // Informações do plantio
      promises.push(InformacoesCultivaresService.getDataPlantio(params).then(function(result) {
        $scope.report.plantio = result.data.data_plantio;
      }));

      // Informações da Cultivar
      promises.push(InformacoesCultivaresService.get(params).then(function(result) {
        $scope.report.informacaoCultivar = (result.data || [])[0];
      }));

      let printer = '#hidden-print';
      if ($scope.details.atividade.isCana) {
        printer = '#hidden-print-cana';
      }

      $q.all(promises).then(function() {
        $scope.report.ready = true;
        LoadingService.hideLoading();
        $timeout(function() {
          angular.element(printer).click();
        });
      })
        .catch(function(error) {
          MessagesService.alert('Ocorreu um erro ao gerar o relatório.');
          console.error('Falha ao gerar relatório', error);
        })
        .finally(LoadingService.hideLoading);
    };

    function activeMarkers() {
      return (($scope.details || {}).markers || []).filter(function(marker) {
        return marker.objeto.registroAtivo && marker.objeto.configuration.informar_distancia;
      });
    }

    function hasInformedDistance(data) {
      return (data || activeMarkers()).length > 0;
    }

    $scope.hasInformedDistance = hasInformedDistance;

    $scope.uniformidadeDistribuicaoAverage = function() {
      const active = activeMarkers();
      return active.reduce(function(total, marker) {
        return total + marker.objeto.uniformidadeDistribuicao;
      }, 0) / active.length || 0;
    };

    $scope.plantasInconformesAverage = function() {
      const active = activeMarkers();
      return active.reduce(function(total, marker) {
        return total + marker.objeto.plantasInconformes;
      }, 0) / active.length || 0;
    };

    // eslint-disable-next-line max-lines-per-function
    $scope.uniformidadeDistribuicaoChart = function() {
      const result = {
        type: 'ColumnChart',
        data: {
          cols: [
            { label: 'Ponto', type: 'string' },
            { label: 'Uniformidade', type: 'number' }
          ]
        },
        options: {
          legend: { position: 'none' },
          height: 200,
          width: 257,
          vAxis: {
            viewWindow: {
              min: 0
            },
            format: '#.##%'
          },
          hAxis: {
            slantedText: true
          }
        }
      };

      if (google && google.visualization) {
        const active = activeMarkers();
        const array = [
          ['Ponto', 'Uniformidade', { role: 'tooltip' }]
        ].concat(active.map(function(marker, index) {
          return [
            `Ponto ${ index }${1}`,
            marker.objeto.uniformidadeDistribuicao / 100,
            `Uniformidade: ${ $filter('number')(marker.objeto.uniformidadeDistribuicao, 2) }%`
          ];
        }));
        result.data = google.visualization.arrayToDataTable(array);
      }

      return result;
    };
  });
